import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { MenuBaseActions } from './menu-base.actions';
import { MenuBaseSelectors } from './menu-base.selectors';
import {CoreStoreService} from '@emm/core/store/core-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';


export interface BaseQueries {
    effectiveDate$: Observable<string>;
    isFutureDate$: Observable<boolean>;
    isInitialized$: Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class MenuBaseStoreService extends CoreStoreService {

    constructor(store: Store<CoreState>) {
        super(store);
    }



    dispatch = {
        changeEffectiveDate: (effectiveDate: string) =>
            this.store.dispatch(MenuBaseActions.changeEffectiveDate({ effectiveDate })),
        init: () =>
            this.store.dispatch(MenuBaseActions.init())
    };



    queries: BaseQueries = {
        effectiveDate$: this.select(MenuBaseSelectors.getEffectiveDate),
        isFutureDate$: this.select(MenuBaseSelectors.getIsFutureDate),
        isInitialized$: this.select(MenuBaseSelectors.getIsInitialized)
    };



}
